// extracted by mini-css-extract-plugin
export default {"parentLetters":"parentLetters-aaYTG","parentLetter":"parentLetter-wx52q","studentName":"studentName-K_BgU","letter":"letter-FI3xR"};